<i18n lang="yaml">
ru:
  change_delivery_success: 'Запрос на изменение адреса доставки отправлен. Ваш менеджер свяжется с Вами в течение 24 часов'
en:
  change_delivery_success: 'Your delivery address request has been sent. Our manager will contact you in 24 hours'
</i18n>

<template>
  <modal :visible="visible" @close="visible = false">
    <template v-slot:header>
      <div></div>
    </template>
    <template v-slot:body>
      <div>
        {{ $t('change_delivery_success') }}
      </div>
    </template>
    <template v-slot:footer>
      <button class="modal-default-button" @click="visible = false">{{ $t('continue') }}</button>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/modal';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    submit() {
      this.$axios.$post('/user/user-send-notification/', {event: 'user_address_change'}).then(() => {
        this.visible = true;
      });
    },
  },
}
</script>
